import React from 'react'
import { Switch } from 'react-router-dom'
import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { PublicRoute, PrivateRoute } from './routePermission'

//Layout
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank')
})
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster')
})
const LayoutOther = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutOther')
})
const LayoutMasterLocation = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMasterLocation')
})
// const layoutMasterChartCentral1 = LoadableRoute({
//     loader: () => import('../components/layout/controllers/layoutMasterChartCentral1')
// })
// const LayoutMasterData = LoadableRoute({
//     loader: () => import('../components/layout/controllers/layoutMasterData')
// })

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeController')
})
// MapView
const HomeSiteController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeSiteController')
})
const NorthernRegionController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/northernRegionController')
})
const NortheasternRegionController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/northeasternRegionController')
})
const SouthernRegionController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/southernRegionController')
})
// TableView
const homeStationController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeStationController')
})

// DataView
const HomeDeviceController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeDeviceController')
})
// User
const UserController = LoadableRoute({
    loader: () => import('../components/features/user/controllers/userListController')
})
// Login
const LoginController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/loginController')
})
// Forgot Password
const ForgotPasswordController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/forgotPasswordController')
})
// Setting Admin
const SettingAdminController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/settingAdminController')
})
// Report
const ReportController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/reportController')
})
// const DashboardController = LoadableRoute({
//     loader: () => import('../components/features/dashboard/controllers/dashboardController')
// })
const SiteController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/site/controllers/siteController')
})
const CreateSiteController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/site/controllers/createSiteController')
})
const UpdateSiteController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/site/controllers/updateSiteController')
})

const ViewSiteController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/site/controllers/viewSiteController')
})

const UserControllerAdminSetting = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/users/controllers/userController')
})
const CreateUserController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/users/controllers/createUserController')
})
const UpdateUserController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/users/controllers/updateUserController')
})
const ViewUserController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/users/controllers/viewUserController')
})

const UserGroupController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/userGroup/controllers/userGroupController')
})
const CreateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/userGroup/controllers/createUserGroupController')
})
const UpdateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/userGroup/controllers/updateUserGroupController')
})
const ViewUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/userGroup/controllers/viewUserGroupController')
})
// const ProfileController = LoadableRoute({
//     loader: () => import('../components/features/profile/controllers/profileController')
// })
const SettingDeviceController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/settingDevice/controllers/settingDeviceController')
})
const ViewSettingDeviceController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/settingDevice/controllers/viewSettingDeviceController')
})
const UpdateSettingDeviceController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/settingDevice/controllers/updateSettingDeviceController')
})
const CompanyController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/company/controllers/companyController')
})
const CreateCompanyController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/company/controllers/createCompanyController')
})
const ViewCompanyController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/company/controllers/viewCompanyController')
})
const UpdateCompanyController = LoadableRoute({
    loader: () => import('../components/features/settingAdmin/company/controllers/updateCompanyController')
})

export default () => (
    <Switch>
        <PrivateRoute path="/adminSetting/site/update/:id" component={UpdateSiteController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/site/view/:id" component={ViewSiteController} layout={LayoutOther} />

        <PrivateRoute path="/adminSetting/device/view/:id" component={ViewSettingDeviceController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/device/update/:id" component={UpdateSettingDeviceController} layout={LayoutOther} />

        <PrivateRoute path="/adminSetting/company/view/:id" component={ViewCompanyController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/company/update/:id" component={UpdateCompanyController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/company/create" component={CreateCompanyController} layout={LayoutOther} />

        <PrivateRoute path="/adminSetting/user/update/:id" component={UpdateUserController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/user/view/:id" component={ViewUserController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/userGroup/update/:id" component={UpdateUserGroupController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/userGroup/view/:id" component={ViewUserGroupController} layout={LayoutOther} />

        <PrivateRoute path="/adminSetting/site/create" component={CreateSiteController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/user/create" component={CreateUserController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/userGroup/create" component={CreateUserGroupController} layout={LayoutOther} />

        <PrivateRoute path="/adminSetting/device" component={SettingDeviceController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/company" component={CompanyController} layout={LayoutOther} />
        {/* <PrivateRoute path="/adminSetting/profile" component={ProfileController} layout={LayoutOther} /> */}
        <PrivateRoute path="/adminSetting/site" component={SiteController} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/user" component={UserControllerAdminSetting} layout={LayoutOther} />
        <PrivateRoute path="/adminSetting/userGroup" component={UserGroupController} layout={LayoutOther} />


        <PublicRoute exact path="/dashboard/device/:id/:id2/:id3/:id4" component={HomeDeviceController} layout={LayoutMaster} />
        <PublicRoute exact path="/dashboard/station/:id/:id2" component={homeStationController} layout={LayoutMaster} />
        <PublicRoute exact path="/dashboard/site/:id" component={HomeSiteController} layout={LayoutMaster} />
        <PublicRoute exact path="/dashboard/northernRegion" component={NorthernRegionController} layout={LayoutMasterLocation} />
        <PublicRoute exact path="/dashboard/northeasternRegion" component={NortheasternRegionController} layout={LayoutMasterLocation} />
        <PublicRoute exact path="/dashboard/southernRegion" component={SouthernRegionController} layout={LayoutMasterLocation} />
        
        <PublicRoute exact path="/dashboard" component={HomeController} layout={LayoutMaster} />
        <PublicRoute exact path="/users" component={UserController} layout={LayoutBlank} />
        {/* <PublicRoute exact path="/dashboard" component={DashboardController} layout={LayoutBlank} /> */}
        {/* <PublicRoute exact path="/" component={HomeController} layout={LayoutMaster} /> */}
        <PrivateRoute path="/adminSetting" component={SettingAdminController} layout={LayoutOther} />
        <PrivateRoute path="/report" component={ReportController} layout={LayoutMaster} />
        <PublicRoute exact path="/forgotPassword" component={ForgotPasswordController}  layout={LayoutBlank}/>
        <PublicRoute exact path="/login" component={LoginController}  layout={LayoutBlank}/>
        <PublicRoute exact path="/" component={LoginController}  layout={LayoutBlank}/>
    </Switch>
)



// WEBPACK FOOTER //
// ./src/app/routes/Routes.js